import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import TaskRouteComponent from '@/features/tasks/components/TaskRouteComponent'

function parseAssetIds(search: Record<string, unknown>): Array<string> {
  const raw = search.assetIds
  if (Array.isArray(raw)) {
    return raw.filter((v): v is string => typeof v === 'string' && v.length > 0)
  }
  // TanStack Router may leave array as JSON string in URL (e.g. ["id1"] or [])
  if (typeof raw === 'string' && raw.length > 0) {
    const trimmed = raw.trim()
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed) as unknown
        if (Array.isArray(parsed)) {
          return parsed.filter((v): v is string => typeof v === 'string' && v.length > 0)
        }
      } catch {
        // fall through to comma-split
      }
    }
    return raw.split(',').map((s) => s.trim()).filter(Boolean)
  }
  // Backward compatibility: single assetId
  const single = search.assetId
  if (typeof single === 'string' && single.length > 0) {
    return [single]
  }
  return []
}

export const Route = createFileRoute('/_authed/tasks/')({
  validateSearch: (search: Record<string, unknown>) => ({
    assetIds: parseAssetIds(search),
  }),
  loaderDeps: ({ search: { assetIds } }) => ({ assetIds }),
  loader: async ({ context }) => {
    // Unified schema: uses api.tasks.getDueTasks (replaces api.recurring.getDueTasks)
    await Promise.all([
      context.queryClient.ensureQueryData(
        convexQuery(api.tasks.getDueTasks, { daysAhead: 90 })
      ),
      context.queryClient.ensureQueryData(convexQuery(api.assets.getInventory, {})),
    ])
  },
  pendingComponent: () => <LoadingScreen message="Loading tasks..." />,
  component: TaskRouteComponent,
})
